module.exports = __webpack_public_path__ + "img/715e19f5-fea4-9361-a1e3-0f04d595db660.b23ed18f.webp";